import {BrowserModule} from '@angular/platform-browser';
import {NgModule, APP_INITIALIZER, LOCALE_ID} from '@angular/core';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AppRoutingModule} from './app-routing.module';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {TokenInterceptor} from './core/services/auth.interceptor';
import {ApplicationInsightsService} from './core';
import {DomainModule} from './domain/domain.module';
import {SharedModule} from './shared/shared.module';
import {CoreModule} from './core/core.module';
import {Footer} from './components/footer/footer.component';
import {SettingsProvider} from './core/services/settings.service';
import {PermissionService} from './core/services/permission.service';
import {NotificationDataService} from './core/services/notification.data.service';

import localePl from '@angular/common/locales/pl';
import {registerLocaleData} from '@angular/common';
import {AdalService} from 'adal-angular4';
import { LoginComponent } from './components/login/login.component';
import { TopsOptionComponent } from './prices/price-simulation/simulation-steps/step-rules/tops-rule/tops-option/tops-option.component';

registerLocaleData(localePl);

export function init(settingsProvider: SettingsProvider) {
    return () => settingsProvider.loadConfig();
}

@NgModule({
    declarations: [
        AppComponent,
        Footer,
        LoginComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        SharedModule,
        AppRoutingModule,
        CoreModule,
        DomainModule,
    ],
    providers: [
        ApplicationInsightsService,
        AdalService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true,
        },
        {
            provide: APP_INITIALIZER,
            useFactory: init,
            deps: [SettingsProvider],
            multi: true,
        },
        SettingsProvider,
        PermissionService,
        NotificationDataService,
        {
            provide: LOCALE_ID,
            useValue: 'pl',
        },
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
